// extracted by mini-css-extract-plugin
module.exports = {"banner":"PackDashboardBanner_banner__K6z3z"};